import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import Box from '@ntuctech/devex-tangram/Box';

const FormElementSC = styled(Box)`
  display: ${(props) => (props.hiddenInput ? 'none' : 'block')};

  ${(props) =>
    props.hasMobileSpacing &&
    `@media (max-width: ${parseInt(props.theme.SizeBreakpointsS, 10) - 1}px) {
      margin-bottom: 1rem !important;
    }`}

  ${(props) =>
    props.removeInputSpacing &&
    `& ._ndsFormControl {
      margin-bottom: 0;
    }`}
`;

function FormElement({ children, hidden, spacing: spacingProp, compact }) {
  const defaultSpacing = { mb: 2 };
  const spacing = { ...defaultSpacing, ...spacingProp, ...(compact && { mb: 0 }) };

  return (
    <FormElementSC hiddenInput={hidden} {...spacing} {...(compact && { removeInputSpacing: true })}>
      {children}
    </FormElementSC>
  );
}

FormElement.defaultProps = {
  hidden: false,
  spacing: {},
  compact: false,
};

FormElement.propTypes = {
  children: PropTypes.node.isRequired,
  hidden: PropTypes.bool,
  // eslint-disable-next-line react/forbid-prop-types
  spacing: PropTypes.object,
  compact: PropTypes.bool,
};

export default FormElement;
